import React from 'react';
import { TextSmallarea } from 'src/core';
import { TextQuestionProps } from './text-question.props';
import styles from './text-question.module.scss';

/**
 * <TextQuestion />
 */
const TextSmallQuestion: React.FC<TextQuestionProps> = ({ ...props }) => (
  <div className={styles.text_question}>
    <TextSmallarea {...props} />
  </div>
);

export { TextSmallQuestion };
